// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2X26I","inner":"Footer_inner__1a5Fz","nextIcon":"Footer_nextIcon__i-e8c","innerLeft":"Footer_innerLeft__64NG_"};